import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

export const authApi = {
  login: (email, password) => api.post('/auth/login', { email, password }).then(unwrap),
  verifyMfa: (challengeId, code) => api.post('/auth/mfa/verify', { challengeId, code }).then(unwrap),
  loginBackup: (challengeId, backup_code) => api.post('/auth/mfa/backup', { challengeId, backup_code }).then(unwrap),
  refresh: (refreshToken) => api.post('/auth/refresh', { refreshToken }).then(unwrap),
  logout: (refreshToken) => api.post('/auth/logout', { refreshToken }).then(unwrap),
  me: () => api.get('/auth/me').then(unwrap),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }).then(unwrap),
  resetPassword: (token, password) => api.post('/auth/reset-password', { token, password }).then(unwrap),
  // MFA enrollment (authenticated)
  mfaSetup: () => api.post('/auth/mfa/setup').then(unwrap),
  mfaConfirm: (code) => api.post('/auth/mfa/confirm', { code }).then(unwrap),
  mfaDisable: (code) => api.delete('/auth/mfa/disable', { data: { code } }).then(unwrap),
  mfaStatus: () => api.get('/auth/mfa/status').then(unwrap),
};
